import { render, staticRenderFns } from "./EditSupportTicket.vue?vue&type=template&id=a22b63a0&scoped=true"
import script from "./EditSupportTicket.vue?vue&type=script&lang=js"
export * from "./EditSupportTicket.vue?vue&type=script&lang=js"
import style0 from "./EditSupportTicket.vue?vue&type=style&index=0&id=a22b63a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22b63a0",
  null
  
)

export default component.exports